import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as svc from './planes-service';
import { planesKeys } from './keys';
import type { CreatePlanDto, UpdatePlanDto, QueryPlanesDto } from './planes-service';

export function usePlanesList(params: QueryPlanesDto) {
  return useQuery({
    queryKey: planesKeys.list(params as unknown as Record<string, unknown>),
    queryFn: () => svc.getPlanes(params),
    staleTime: 30_000,
  });
}

export function usePlan(id: number) {
  return useQuery({
    queryKey: planesKeys.detail(id),
    queryFn: () => svc.getPlan(id),
    enabled: id > 0,
    staleTime: 30_000,
  });
}

export function useCreatePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreatePlanDto) => svc.createPlan(dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: planesKeys.lists() });
    },
  });
}

export function useUpdatePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: number; dto: UpdatePlanDto }) => svc.updatePlan(id, dto),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: planesKeys.detail(variables.id) });
      qc.invalidateQueries({ queryKey: planesKeys.lists() });
    },
  });
}

export function useDeletePlan() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => svc.deletePlan(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: planesKeys.lists() });
    },
  });
}
